import Input from "@amzn/meridian/input";
import React, { useState } from "react";
import Select, { SelectOption } from "@amzn/meridian/select";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import { CurrencySymbol } from "./constants";
import Alert from "@amzn/meridian/alert";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import Currency from "./currency";
import {EXCESS_VARIANCE_REASON, ROUND_OFF_EXCESS} from "./remittanceV2Constants";
import { getIssueLinkRegExp } from "./commonUtils";

const ttRegExp = getIssueLinkRegExp();
const AddListItem = ({ varianceReasons, updateVarianceReasons, insertListItem, currency }) => {
    const [selectedVarianceReason, setSelectedVarianceReason] = useState({});
    const [ttLink, setTTLink] = useState();
    const [amount, setAmount] = useState();
    const [errorMessage, setErrorMessage] = useState();

    const onSelectedVarianceReasonChange = (reasonCode) => {
        setSelectedVarianceReason(varianceReasons.filter(varianceReason => varianceReason.reasonCode === reasonCode)[0]);
        setTTLink();
        setAmount();
    }

    /**
     * Validates excess variance input
     * @returns boolean
     */
    const validateInputs = () => {
        let error;
        if (!selectedVarianceReason.reasonCode) {
            error = "Please select a reason";
        } else if (!amount || amount <= 0) {
            error = "Please enter a valid amount";
        } else if (selectedVarianceReason.requireIssueLink && (!ttLink || !ttRegExp.test(ttLink))) {
            error = "Please enter a valid TT issue Link";
        } else if (selectedVarianceReason.reasonCode === ROUND_OFF_EXCESS && amount >= 1) {
            //Validate the amount for reason : ROUND_OFF which should be less than Rs1.
            error = "Please enter amount less than " + CurrencySymbol[currency] + " 1";
        }

        setErrorMessage(error);
        return !error;
    };

    /**
     * Adds excess variance to excess variance list
     */
    const addItem = () => {
        if (validateInputs()) {
            insertListItem({
                varianceReason: selectedVarianceReason,
                ttLink: ttLink,
                amount: {value: Number.parseFloat(amount), unit: currency},
            });
            // Removes the reason from the drop down that has been added to excess variance list
            updateVarianceReasons(selectedVarianceReason);
            // Clear all input fields
            setTTLink();
            setAmount();
            setSelectedVarianceReason({});
        }
    };

    const clearErrorMessage = () => {
        setErrorMessage();
    };

    return (
        <React.Fragment>
            <Row>
                <Select
                    value={selectedVarianceReason.reasonCode}
                    onChange={onSelectedVarianceReasonChange}
                    placeholder="Select a reason"
                    width={180}
                    onFocus={clearErrorMessage}
                >
                    {varianceReasons.map((varianceReason) => (
                        <SelectOption
                            value={varianceReason.reasonCode}
                            label={varianceReason.reasonLabel}
                            key={varianceReason.reasonCode}
                        />
                    ))}
                </Select>
                <Input
                    placeholder="Enter amount"
                    type="number"
                    value={amount}
                    onChange={setAmount}
                    width={180}
                    onFocus={clearErrorMessage}
                    prefix={CurrencySymbol[currency]}
                />
                <Input
                    placeholder="Enter TT link"
                    disabled={!selectedVarianceReason.requireIssueLink}
                    value={ttLink}
                    onChange={setTTLink}
                    width={180}
                    onFocus={clearErrorMessage}
                />
                <Button size="medium" minWidth={100} onClick={addItem}>
                    Add
                </Button>
            </Row>
            {errorMessage && <Alert type="error">{errorMessage}</Alert>}
        </React.Fragment>
    );
};

const ListItem = ({variance, removeItem}) => {
    const { varianceReason, amount, ttLink } = variance;
    return (
        <Row>
            <Box width={180} type="outline" spacingInset="small">
                <Text type="b300">{varianceReason.reasonLabel}</Text>
            </Box>
            <Box width={180} type="outline" spacingInset="small">
                <Currency amount={amount} isVariance={true} />
            </Box>
            <Box width={180} type="outline" spacingInset="small">
                {ttLink && <Link href={ttLink} target="_blank" rel="noopener noreferrer">{ttLink.split('/').pop()}</Link>}
                {!ttLink && <Text>Not Applicable</Text>}
            </Box>
            <Button type="secondary" onClick={() => removeItem(varianceReason)} minWidth={100}>
                Remove
            </Button>
        </Row>
    );
};

const ExcessVarianceList = ({ excessVarianceList, setExcessVarianceList, currency }) => {
    const [varianceReasons, setVarianceReasons] = useState(EXCESS_VARIANCE_REASON);
    const updateVarianceReasons = (selectedVarianceReason) => {
        setVarianceReasons([...varianceReasons].filter((option) => option !== selectedVarianceReason));
    }
    const insertExcessVariance = (data) => {
        setExcessVarianceList([...excessVarianceList, data]);
    };
    
    // Removes the variance from excess variance list and update the drop down reasons
    const removeExcessVariance = (varianceReason) => {
        setExcessVarianceList([...excessVarianceList].filter(data => data.varianceReason.reasonCode !== varianceReason.reasonCode));
        setVarianceReasons([...varianceReasons, varianceReason]);
    };


    
    return (
        <React.Fragment>
            <Column spacingInset="small none none none">
                <AddListItem
                    varianceReasons={varianceReasons}
                    updateVarianceReasons={updateVarianceReasons}
                    insertListItem={insertExcessVariance}
                    currency={currency}
                />

                {excessVarianceList.map(variance => (
                    <ListItem
                        variance={variance}
                        removeItem={removeExcessVariance}
                    />
                ))}
            </Column>
        </React.Fragment>
    );
};

export default ExcessVarianceList;



// WEBPACK FOOTER //
// ./src/component/common/excessVarianceList.js